import { render, staticRenderFns } from "./_transHistory.vue?vue&type=template&id=c41695d8&lang=pug&"
import script from "./_transHistory.vue?vue&type=script&lang=js&"
export * from "./_transHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports